import React from 'react';

const QuizViewContext = React.createContext({
  save: {},
});

export default QuizViewContext;
